// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3xZLA","col":"Table_col__zc7ni","fulfillmentStatus":"Table_fulfillmentStatus__2WSta","emailCol":"Table_emailCol__2cMF7"};